import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    margin: '0',
    padding: '6px',
    cursor: ({ disabled }) => (disabled ? 'default' : 'pointer')
  },

  menu: {
    border: '1px solid #EAEAEA',
    borderRadius: '7px',
    boxSizing: 'border-box',
    boxShadow: '0px 20px 30px rgba(0, 0, 0, 0.15)',
    width: 'auto',
    background: 'white'
  },

  list: {
    paddingTop: '12px',
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingBottom: '12px'
  },

  item: {
    width: '100%',
    padding: '8px',
    fontSize: theme.size.base,
    color: '#1F1F1F',
    cursor: 'pointer',
    '& svg': {
      height: ({ smallIcons }) => smallIcons && '14px',
      width: ({ smallIcons }) => smallIcons && '14px'
    }
  },

  title: {
    marginBottom: '8px',
    borderBottom: '1px solid #C6C6C6',
    boxSizing: 'border-box',
    height: '44px',
    padding: '16px 0 0 16px',
    fontSize: theme.size.sm,
    cursor: 'default'
  },

  disabledItem: {
    color: '#8F8F8F',
    cursor: 'default'
  },

  icon: {
    flexShrink: '0',
    marginRight: '8px'
  }
}))

export default useStyles
